import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ref, watch } from "vue";
import { getCurrentGalaxyHistory } from "@/utils/data";
import DataDialog from "@/components/DataDialog/DataDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormDataDialog',
    props: {
        id: null,
        multiple: { type: Boolean, default: false },
        value: { default: "" }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faFolderOpen);
        const title = "Browse Datasets";
        const localHistoryId = ref("");
        const dataDialogOpen = ref(false);
        watch(() => dataDialogOpen.value, async () => {
            localHistoryId.value = "";
            localHistoryId.value = await getCurrentGalaxyHistory();
        });
        function onData(result) {
            dataDialogOpen.value = false;
            emit("input", result);
        }
        return { __sfc: true, props, title, localHistoryId, dataDialogOpen, emit, onData, FontAwesomeIcon, DataDialog };
    }
});
